import getStyles from "./styles";
import ImageViewer from "./ImageViewer";
import { Grid, Tooltip } from "@mui/material";
import { Undo, ZoomIn, ZoomOut, Compare, Fullscreen } from "@mui/icons-material";
import { useControls } from "./hooks";

interface IImageControls {
  image: string;
  alt?: string;
  ref?: any;
  imgHeight: number;
  imgControl: boolean;
}

export default function _ImageControls(props: IImageControls) {
  const styles = getStyles();
  const { image, alt, ref, imgHeight, imgControl } = props;

  const {
    zoomIn,
    zoomOut,
    rotateLeft,
    flipImage,
    resetAll,
    zoom,
    panDiagonalX,
    panDiagonalY,
    onPan,
    setZoom,
    rotation,
    flip,
    onWheel,
  } = useControls();

  return (
    <Grid container direction="row" alignItems="flex-start" textAlign={"center"}>
      <Grid item xs={11} xl={11} sx={{}}>
        <ImageViewer
          onWheel={imgControl ? onWheel : undefined}
          zoom={zoom}
          panDiagonalX={panDiagonalX}
          panDiagonalY={panDiagonalY}
          styles={styles}
          key={panDiagonalX}
          onPan={onPan}
          setZoom={setZoom}
          rotation={rotation}
          imgHeight={imgHeight}
          image={image}
          alt={alt}
          ref={ref}
          flip={flip}
        />
      </Grid>
      <Grid item xs={1} xl={1} textAlign={"center"} sx={{ zIndex: 2, display: imgControl ? "block" : "none" }}>
        <Grid container direction="column" justifyContent="space-evenly" alignItems="flex-start" textAlign={"center"}>
          <Grid item onClick={zoomIn} sx={styles.button}>
            <Tooltip title="Zoom in" placement="left">
              <ZoomIn />
            </Tooltip>
          </Grid>

          <Grid item onClick={zoomOut} sx={styles.button}>
            <Tooltip title="Zoom out" placement="left">
              <ZoomOut />
            </Tooltip>
          </Grid>

          <Grid item onClick={rotateLeft} sx={styles.button}>
            <Tooltip title="Rotate left" placement="left">
              <Undo />
            </Tooltip>
          </Grid>

          <Grid item onClick={flipImage} sx={styles.button}>
            <Tooltip title="Mirror image" placement="left">
              <Compare />
            </Tooltip>
          </Grid>

          <Grid item onClick={resetAll} sx={styles.button}>
            <Tooltip title="Re-center image" placement="left">
              <Fullscreen />
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
